import React, {useEffect, useState, useRef} from 'react';
import './CompareEntry.sass';
import apiJSON from "../../../api/apiJSON";
import StandardButton from "../../ui/Button/StandardButton";
import renderHTML from 'react-render-html';
import {gsap} from "gsap";

const CompareEntry = ({data, next, completed}) => {

    const jsonData = apiJSON.get(data);
    const {scenario} = jsonData;
    const [feedback, setFeedback] = useState(null);
    const [entry, setEntry] = useState("");
    const textArea = useRef(null);

    useEffect(()=>{
        if(feedback)
        {
            gsap.set(".compare-entry-feedback",{position:"absolute",right:"-1200px"})
            gsap.to(".compare-entry-input",{position:"absolute",left:"100px",ease:"expo.out"})
            gsap.to(".compare-entry-feedback",{position:"absolute",right:"100px",ease:"expo.out"})
        }

    },[feedback])

    const updateEntry = () => {
        setEntry(textArea.current.value)
    }

    const focusTextArea = () => {
        if (!entry) {
            textArea.current.value = "";
        }
    }

    const onSubmit = () => {
        setFeedback(scenario.feedback)
        completed();
    }

    return (
        <div className="CompareEntry">
            <div className="compare-entry-header">
                <div className="compare-entry-header-title">
                    {scenario.title}
                </div>
                <div className="compare-entry-header-body">
                    {scenario.body}
                </div>
            </div>
            <div className={"compare-entry-input"}>
                <div className="compare-entry-input-title">
                    {scenario.input.title}
                </div>
                <div className="compare-entry-divider"/>
                <textarea
                    ref={textArea}
                    type="text"
                    className="compare-entry-input-body"
                    onChange={updateEntry}
                    onClick={focusTextArea}
                    defaultValue={scenario.input.body}/>
                <StandardButton data={"SUBMIT"}
                                disabled={!entry}
                                callback={onSubmit}
                                style={{
                                    "position": "relative",
                                    "width": "fit-content",
                                    "visibility":(feedback?"hidden":"visible")
                                }}/>
            </div>
            <div className="compare-entry-feedback">
                <div className={"compare-entry-feedback-title"}>
                    {scenario.feedback.title}
                </div>
                <div className="compare-entry-divider"/>
                <div className="compare-entry-feedback-body">
                    {renderHTML(scenario.feedback.body)}
                </div>
            </div>

        </div>

    );
};

export default CompareEntry;